import type { IPage } from '@/models/global'

const platformList = ['tb', 'jd', 'dy', 'ks', 'pdd', 'open', 'wx']

export const nameIdMap: Record<string, string> = {
  告警大屏: '6690db299ed071e51721831e',
  // 质检诊断报告页面和质检明细报表页面淘宝平台与其他平台的不同，所以写了两个质检诊断报告
  质检诊断报告_tb: '68a691a6ad2af9f81792f639',
  质检诊断报告: '68a692e363b844321133abde',
  质检明细报表_tb: '67de4ee9ac92a95fb638f316',
  质检明细报表: '66a1fd3b22ab809971104e06',
  实时告警报表: '6691f6d522ab80997110364b',
  店铺实时告警: '66922f2822ab809971103a55',
  全局告警统计: '66922f2822ab809971103a49',
  平台告警统计: '66922f2822ab809971103a4f',
  客服评价满意度_tb: '67d2461ce63366f0474b20b0',
  客服评价满意度_jd: '6692264d22ab8099711037a3',
  // voc-咨询热点
  商品热点报告_tb: '67de683eac92a95fb638f3bd',
  商品热点报告: '6668021f3b1c08954549cc52',
  商品咨询统计_tb: '67de683eac92a95fb638f3c9',
  商品咨询统计: '6697390e22ab809971103d3d',
  // voc-商品流失分析
  商品流失报告: '6697379622ab809971103c19',
  商品流失报告_tb: '67de683eac92a95fb638f3c0',
  // 人工
  人工质检诊断报告_tb: '68a691a6ad2af9f81792f636',
  人工质检诊断报告: '68a692b3ad2af9f81792f758',
}
// dataforce页面属于哪些平台
export const idPlatformMap: Record<string, string[]> = {
  [nameIdMap['告警大屏']]: platformList,
  [nameIdMap['质检诊断报告_tb']]: ['tb'],
  [nameIdMap['质检诊断报告']]: platformList.filter((item) => item !== 'tb'),
  [nameIdMap['质检明细报表_tb']]: ['tb'],
  [nameIdMap['质检明细报表']]: platformList.filter((item) => item !== 'tb'),
  [nameIdMap['实时告警报表']]: platformList,
  [nameIdMap['店铺实时告警']]: platformList,
  [nameIdMap['全局告警统计']]: platformList,
  [nameIdMap['平台告警统计']]: platformList,
  [nameIdMap['客服评价满意度_tb']]: ['tb'],
  [nameIdMap['客服评价满意度_jd']]: ['jd'],
  [nameIdMap['商品热点报告_tb']]: ['tb'],
  [nameIdMap['商品热点报告']]: platformList.filter((item) => item !== 'tb'),
  [nameIdMap['商品咨询统计_tb']]: ['tb'],
  [nameIdMap['商品咨询统计']]: platformList.filter((item) => item !== 'tb'),
  [nameIdMap['商品流失报告']]: platformList.filter((item) => item !== 'tb'),
  [nameIdMap['商品流失报告_tb']]: ['tb'],
  [nameIdMap['人工质检诊断报告']]: platformList.filter((item) => item !== 'tb'),
  [nameIdMap['人工质检诊断报告_tb']]: ['tb'],
}

const V2DataforceList: Record<string, string[]> = {
  集团监控: [nameIdMap['告警大屏']],
  质检分析: [
    nameIdMap['质检诊断报告_tb'],
    nameIdMap['质检诊断报告'],
    nameIdMap['质检明细报表_tb'],
    nameIdMap['质检明细报表'],
  ],
  实时风险分析: [
    nameIdMap['实时告警报表'],
    nameIdMap['店铺实时告警'],
    nameIdMap['全局告警统计'],
    nameIdMap['平台告警统计'],
  ],
  客服评价满意度: [nameIdMap['客服评价满意度_tb'], nameIdMap['客服评价满意度_jd']],
  商品咨询热点: [
    nameIdMap['商品热点报告_tb'],
    nameIdMap['商品热点报告'],
    nameIdMap['商品咨询统计_tb'],
    nameIdMap['商品咨询统计'],
  ],
  商品流失分析: [nameIdMap['商品流失报告_tb'], nameIdMap['商品流失报告']],
  人工质检: [nameIdMap['人工质检诊断报告_tb'], nameIdMap['人工质检诊断报告']],
}

export const handleDataforceV2 = (data: IPage[], platform: string) => {
  const primary_pages = data.flatMap((item) => item.primary_pages) as IPage[]
  const dataforceV2 = Object.keys(V2DataforceList).map((item) => ({
    name: item,
    id: item,
    primary_pages: V2DataforceList[item]
      // .filter(
      //   (id: string) =>
      //     idPlatformMap[id].includes(platform) &&
      //     primary_pages.find((page: IPage) => page.id === id)
      // )
      .map((id: string) => {
        const curPage = primary_pages.find((page: IPage) => page?.id === id) as IPage
        const index = Object.values(nameIdMap).findIndex((idItem) => idItem === id)

        const curName = Object.keys(nameIdMap)[index]
        // 获取名字
        const [name] = (curName ?? '').split('_')
        return {
          ...curPage,
          name:
            name ||
            (curPage.name.includes('-doris') ? curPage.name.replace('-doris', '') : curPage.name),
          hideInMenu: !idPlatformMap[id].includes(platform) ,
          icon: 'icon-kefupingjiamanyidu'
        }
      }),
  }))

  return dataforceV2
}
